function initCarouselActFor() {

    $('.slider-actfor').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1700,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $(".carousel-actfor__tabs__item").click(function () {
        if (!$(this).hasClass('carousel-actfor__tabs__item--current')) {
            $(".carousel-actfor__tabs__item").removeClass('carousel-actfor__tabs__item--current');
            $(this).addClass('carousel-actfor__tabs__item--current');

            $(".slider-actfor").removeClass("slider-actfor--current");
            var $filter = $(this).attr("data-filter");

            $('.' + $filter).addClass("slider-actfor--current");
            $('.' + $filter).get(0).slick.setPosition();
        }
    });

    $('.slick-arrow').text('');
}